// removed by extract-text-webpack-plugin
module.exports = {"tray":"_2xt4","groupTitle":"_2p__","selectedTitle":"_2mtl","selectedBody":"_2ltv","footer":"_2HFN","hidden":"_4X3x"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/Tray/Tray.scss
// module id = XyPG
// module chunks = 0